// src/pages/homepage.js
import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { businessSchemaDE, businessSchemaEN } from "../schema";
import LandingImage from "../components/landing_image/landing_image";
import Company_Display from "../components/company_display/company_display";

// Import homepage translations
import homepageEnTranslations from "../translations/homepage_en.json";
import homepageDeTranslations from "../translations/homepage_de.json";

const HomePage = () => {
  const { t, i18n } = useTranslation();

  // Add translations for this page
  i18n.addResourceBundle("en", "homepage", homepageEnTranslations, true, true);
  i18n.addResourceBundle("de", "homepage", homepageDeTranslations, true, true);

  const currentSchema =
    i18n.language === "en" ? businessSchemaEN : businessSchemaDE;

  return (
    <>
      <Helmet>
        <title>{t("homepage:page_title")}</title>
        <script type="application/ld+json">
          {JSON.stringify(currentSchema)}
        </script>
        <meta name="description" content={t("homepage:meta_description")} />
        <meta name="keywords" content={t("homepage:meta_keywords")} />
        <meta property="og:title" content={t("homepage:og_title")} />
        <meta
          property="og:description"
          content={t("homepage:og_description")}
        />
        <meta property="og:url" content={t("homepage:canonical_url")} />
        <link rel="canonical" href={t("homepage:canonical_url")} />
      </Helmet>
      <>
        <LandingImage />
        <Company_Display />
      </>
    </>
  );
};

export default HomePage;
